import { createContext, useContext } from "react";
const makeCompoundContextHook = (parentContext, parentName) => (name) => {
    const parentDisplayName = parentName || `${parentContext.displayName}Provider`;
    const context = useContext(parentContext);
    if (context === undefined || context === null) {
        throw new Error(`${name} must be used within a ${parentDisplayName}`);
    }
    return context;
};
export const makeCompoundContext = (name) => {
    const context = createContext(undefined);
    context.displayName = `${name}Context`;
    const useCompoundContext = makeCompoundContextHook(context, name);
    return [context.Provider, useCompoundContext];
};
//# sourceMappingURL=compoundContext.js.map